import { sidebarSize, topbarSize } from '../../../../../../../constants/sizes';
import Device from '../../../../../../../constants/deviceSizes';
import Images from '../../../../../../../config/assets';

export default {
  container: {
    backgroundImage: `url(${Images.energyAdvisorBackground})`,
    backgroundPosition: 'center bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: `calc(100vh - ${topbarSize}px)`,
    width: `calc(100vw - ${sidebarSize}px)`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflowY: 'hidden',
    [Device.tablet_mobile]: {
      left: 0
    }
  },
  wheelAvatar: {
    zIndex: 3,
    width: 'auto',
    height: '65vh',
    bottom: '-15%',
    position: 'relative',
    pointerEvents: 'none'
  },
  title: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '30px 40px 15px',
    width: '34%',
    textAlign: 'left',
    [Device.tablet_mobile]: {
      left: 0
    }
  },
  avatarContainer: {
    margin: '0 auto',
    height: '100vh'
  }
};
